module.exports = __webpack_public_path__ + "img/checked-icon-primary.5f29f3d4.svg";